import { render, staticRenderFns } from "./v_Creator_Events.vue?vue&type=template&id=273c4235&scoped=true&"
import script from "./v_Creator_Events.vue?vue&type=script&lang=js&"
export * from "./v_Creator_Events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c4235",
  null
  
)

export default component.exports